module.exports = __webpack_public_path__ + "img/section1.b52bccbb.jpg";